import { render, staticRenderFns } from "./colors-compatibility.form.vue?vue&type=template&id=d9ebbc4a&"
import script from "./colors-compatibility.form.vue?vue&type=script&lang=ts&"
export * from "./colors-compatibility.form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports